@if (_verifyType && _verifyType.toLowerCase() === 'phone') {
  <p tabindex="0" class="text-center">{{ 'MY_ACCOUNT_LOGIN.VERIFY_MESSAGE_PHONE' | translate }}</p>
}
@if (_verifyType && _verifyType.toLowerCase() === 'email') {
  <p tabindex="0" class="text-center">{{ 'MY_ACCOUNT_LOGIN.VERIFY_MESSAGE_EMAIL' | translate }}</p>
}

<form class="col-12 pb-3 code" [formGroup]="codeValidationForm">
  @if ((verifyCodeState$ | async) !== null && (verifyCodeState$ | async) !== 'valid') {
    <div class="alert alert-warning w-100 text-center" role="alert"
      >
      @if ((verifyCodeState$ | async); as code) {
        <span>{{code?.error?.errorMessage}}</span>
      }
    </div>
  }
  <div class="form-row verify-fields md-form">
    <input mdbInput type="text" class="form-control" maxlength="6" (keypress)="onlyNumberKey($event)"
      pattern="[0-9]*" inputmode="numeric" formControlName="code" id="code">
  </div>
  <div class="pt-5 w-100 text-center">
    <button role="button" id="verifyCodeButton" mdbBtn class="btn primary-btn waves-light" mdbWavesEffect type="submit"
      [disabled]="!codeValidationForm.valid || (inlineLoader$ | async) === true"
      (click)="validateCode()">
      @if ((inlineLoader$ | async) === null || (inlineLoader$ | async) === false) {
        <span>
          <mdb-icon fas icon="lock"></mdb-icon> {{ 'MY_ACCOUNT_LOGIN.VERIFIY_CONTINUE' | translate }}
        </span>
      }
      @if ((inlineLoader$ | async) === true) {
        <span>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ 'MY_ACCOUNT_LOGIN.VERIFYING_ACCOUNT' | translate }}
        </span>
      }
    </button>
  </div>
</form>

<div class="w-100 text-center pt-3">
  <span tabindex="0">
    <strong>{{ 'MY_ACCOUNT_LOGIN.NO_CODE' | translate }}</strong><br />
    {{ 'MY_ACCOUNT_LOGIN.GO_BACK' | translate }}<br /><br />
    <a id="retryVerificationLink" href="javascript:void(0)" role="link" (click)="clearForms()"><i
    class="fas fa-arrow-alt-circle-left"></i> {{ 'MY_ACCOUNT_LOGIN.RETRY' | translate }}</a>
    <br /><br />
    {{ 'MY_ACCOUNT_LOGIN.CALL_NUMBER' | translate:{phone:branding.cs_phone_number} }}
  </span>
</div>